import React from 'react'
import I18n from 'translations/i18n'
import PropTypes from 'prop-types'
import { Button, Popper, Grid, Flex, Text } from '@jisr-hr/design-system'

import { ReactComponent as Dots } from 'assets/images/dots-icon.svg'
import FAICon from 'components/fontawesome/FAICon'

import Styles from '../Request.module.css'

const Options = ({ handleCancelRequest, handleCancelImmediately, handlePrint }) => (
  <Popper
    placement="top-start"
    className={Styles.optionsPopper}
    trigger={
      <Button
        size="small"
        icon={
          <Dots
            style={{
              transform: 'rotate(90deg)',
            }}
          />
        }
        variant="secondary"
        onClick={() => {}}
      />
    }
  >
    <Flex
      flexCol
      className={Styles.option}
    >
      <Option
        title={I18n.t('ask_for_cancellation')}
        description={I18n.t('send_cancellation_request')}
        onClick={handleCancelRequest}
      />
      <Option
        title={I18n.t('cancel_immediately')}
        description={I18n.t('cancel_request_immediately')}
        onClick={handleCancelImmediately}
      />
      <Option
        title={I18n.t('print')}
        onClick={handlePrint}
        icon={<FAICon icon="fa fa-print" />}
      />
    </Flex>
  </Popper>
)

Options.propTypes = {
  handleCancelRequest: PropTypes.func,
  handleCancelImmediately: PropTypes.func,
  handlePrint: PropTypes.func,
}

const Option = ({ title, description, onClick, icon }) => (
  <Grid
    container
    onClick={onClick}
  >
    <Grid
      item
      xs={12}
    >
      <Flex flexCol>
        <Flex
          itemsCenter
          style={{ gap: 4 }}
        >
          {icon && icon}
          <Text
            typography="paragraph16"
            color="var(--color-natural-black-default-new)"
          >
            {title}
          </Text>
        </Flex>
        {description && (
          <Text
            typography="paragraph14"
            color="var(--color-natural-black-light-new)"
          >
            {description}
          </Text>
        )}
      </Flex>
    </Grid>
  </Grid>
)

Option.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.node,
}

export default Options
